const getters = {
	getOrganization(state) {
		return state.organization;
	},
};
export default getters;
